/*
  ef-pdp.js — Eternal Flare product page (theme_variant_d, 2026-10-29).
  Reads everything from [data-ef-product] (rendered by sections/ef-main-product.liquid).
  Add to cart: /cart/add.js with items[] + Dawn's cart-drawer sections, then
  <cart-drawer>.renderContents() (same handshake as Dawn's product-form.js).
  The size is preselected server-side (M, else S), so without JS the form posts that variant.
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-ef-pdp]');
  var blob = document.querySelector('[data-ef-product]');
  if (!root || !blob) return;
  var P = JSON.parse(blob.textContent);
  var form = root.querySelector('[data-ef-form]') || document.getElementById('ef-product-form');
  var track = root.querySelector('[data-ef-track]');
  var slides = track ? [].slice.call(track.children) : [];
  var atc = root.querySelector('[data-ef-atc]');
  var hint = root.querySelector('[data-ef-hint]');
  var idInput = root.querySelector('[data-ef-variant]');
  var priceEl = root.querySelector('[data-ef-price]');
  function msg(k, fallback) { return root.getAttribute('data-msg-' + k) || fallback; }

  var colorOpt = P.options.filter(function (o) { return o.kind === 'color'; })[0] || null;
  var sizeOpt = P.options.filter(function (o) { return o.kind === 'size'; })[0] || null;
  var currentId = +idInput.value;
  var current = P.variants.filter(function (v) { return v.id === currentId; })[0] || P.variants[0];

  // selection starts from the current variant (the server preselects a size: M, else S)
  var sel = {};
  P.options.forEach(function (o) { sel[o.position] = current.options[o.position - 1]; });
  if (P.options.length === 1 && P.options[0].name === 'Title') sel[1] = current.options[0];

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function matchVariant() {
    return P.variants.filter(function (v) {
      return P.options.every(function (o) { return sel[o.position] === null || sel[o.position] === undefined || v.options[o.position - 1] === sel[o.position]; });
    });
  }
  function exactVariant() {
    var m = P.variants.filter(function (v) {
      return P.options.every(function (o) { return v.options[o.position - 1] === sel[o.position]; });
    });
    return m[0] || null;
  }
  /* the status region stays in the DOM (empty = no message) so screen readers announce changes */
  function showHint(msg, isError) { hint.textContent = msg || ''; hint.classList.toggle('is-error', !!isError); }
  var sticky = document.querySelector('[data-ef-sticky]');
  var stickyBtn = sticky && sticky.querySelector('[data-ef-sticky-btn]');

  // ---------- gallery ----------
  function markGallery(i) {
    root.querySelectorAll('[data-ef-to]').forEach(function (b) {
      if (+b.getAttribute('data-ef-to') === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  }
  function go(i, smooth) {
    if (!track || i < 0) return;
    markGallery(i);
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  }
  function slideFor(color) {
    for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-color') === color) return i;
    return -1;
  }
  var settle = null;
  if (track) {
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      markGallery(i);
      clearTimeout(settle);
      settle = setTimeout(function () {
        var c = slides[i] && slides[i].getAttribute('data-color');
        if (colorOpt && c && c !== sel[colorOpt.position]) setColor(c, true);
      }, 140);
    }, { passive: true });
    window.addEventListener('resize', function () { var i = colorOpt ? slideFor(sel[colorOpt.position]) : 0; if (i >= 0) track.scrollLeft = i * track.clientWidth; });
  }
  root.querySelectorAll('[data-ef-to]').forEach(function (b) {
    b.addEventListener('click', function () { go(+b.getAttribute('data-ef-to'), true); });
  });

  // ---------- options ----------
  function refreshVariant() {
    var v = exactVariant();
    var shown = v || matchVariant()[0] || current;
    if (v) { idInput.value = v.id; }
    priceEl.innerHTML = money(shown.price) + (shown.compare > shown.price ? '<s>' + money(shown.compare) + '</s>' : '');
    // size boxes: strike sizes that are sold out for the chosen colour
    if (sizeOpt) {
      root.querySelectorAll('input[data-ef-opt="' + sizeOpt.position + '"]').forEach(function (r) {
        var probe = {}; Object.keys(sel).forEach(function (k) { probe[k] = sel[k]; }); probe[sizeOpt.position] = r.value;
        var hit = P.variants.filter(function (vv) { return P.options.every(function (o) { return vv.options[o.position - 1] === probe[o.position]; }); })[0];
        r.disabled = !hit || !hit.available;
        if (r.disabled && r.checked) { r.checked = false; sel[sizeOpt.position] = null; setOptLabel(sizeOpt.position, ''); }
      });
    }
    /* no size picked yet: enabled while any variant of the current selection can still be bought */
    atc.disabled = v ? !v.available : !matchVariant().some(function (x) { return x.available; });
    refreshAtc();
    if (colorOpt && history.replaceState && v) {
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
  }
  function setOptLabel(pos, text) { var l = root.querySelector('[data-ef-opt-label="' + pos + '"]'); if (l) l.textContent = text; }

  function setColor(name, fromSlide) {
    if (!colorOpt) return;
    sel[colorOpt.position] = name;
    var lab = root.querySelector('[data-ef-color-label]'); if (lab) lab.textContent = name.toLowerCase();
    root.querySelectorAll('[data-ef-color]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-ef-color') === name)); });
    root.querySelectorAll('[data-ef-set-color]').forEach(function (w) { w.hidden = w.getAttribute('data-ef-set-color') !== name; });   /* complete-the-set follows the colour */
    if (!fromSlide) go(slideFor(name), true);
    refreshVariant();
  }
  root.querySelectorAll('[data-ef-color]').forEach(function (b) {
    b.addEventListener('click', function () { setColor(b.getAttribute('data-ef-color'), false); });
  });
  root.querySelectorAll('input[data-ef-opt]').forEach(function (r) {
    if (r.checked) setOptLabel(r.getAttribute('data-ef-opt'), r.value);
    r.addEventListener('change', function () {
      sel[+r.getAttribute('data-ef-opt')] = r.value;
      setOptLabel(r.getAttribute('data-ef-opt'), r.value);
      showHint('');
      refreshVariant();
    });
  });

  // ---------- bundle tiers ----------
  var tierInputs = [].slice.call(root.querySelectorAll('input[name="ef-bundle"]'));
  function tierQty() { var t = tierInputs.filter(function (i) { return i.checked; })[0]; return t ? +t.value : 1; }
  var pairState = {}; // "tier:n" -> {pair index, size}
  root.querySelectorAll('[data-ef-pair]').forEach(function (box) {
    if (!P.pairs || !P.pairs.length) return;
    var n = +box.getAttribute('data-ef-pair'), tier = +box.getAttribute('data-ef-tier');
    var key = tier + ':' + n;
    var selfIdx = 0;
    for (var i = 0; i < P.pairs.length; i++) if ((P.pairs[i].name || '').toLowerCase() === (P.self || '').toLowerCase()) selfIdx = i;
    var st = pairState[key] = { idx: (selfIdx + n - 1) % P.pairs.length, size: null };
    var colorsBox = box.querySelector('[data-ef-pair-colors]');
    var sizesBox = box.querySelector('[data-ef-pair-sizes]');
    colorsBox.innerHTML = P.pairs.map(function (p, i) {
      return '<button type="button" data-i="' + i + '" aria-label="' + esc(p.name.toLowerCase()) + '">' + (p.img ? '<img src="' + esc(p.img) + '" width="40" height="40" alt="" loading="lazy">' : '') + '</button>';
    }).join('');
    function paint() {
      var p = P.pairs[st.idx];
      box.querySelector('[data-ef-pair-name]').textContent = p.name.toLowerCase() + (st.size ? ' · ' + st.size : '');
      colorsBox.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-i') === st.idx)); });
      var sizes = Object.keys(p.sizes);
      if (st.size && (!p.sizes[st.size] || !p.sizes[st.size].available)) st.size = null;
      sizesBox.innerHTML = sizes.map(function (s) {
        var ok = p.sizes[s].available;
        return '<button type="button" data-s="' + esc(s) + '" aria-pressed="' + (st.size === s) + '"' + (ok ? '' : ' disabled') + '>' + esc(s) + '</button>';
      }).join('');
    }
    colorsBox.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; st.idx = +b.getAttribute('data-i'); paint(); });
    sizesBox.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b || b.disabled) return; st.size = b.getAttribute('data-s'); paint(); showHint(''); });
    paint();
  });
  function tierPrice(q) { var t = (P.tiers || []).filter(function (x) { return x.qty === q; })[0]; return t ? t.price : null; }
  function refreshAtc() {
    if (atc.disabled) { atc.textContent = msg('soldout', 'sold out'); syncSticky(); return; }
    var q = tierQty();
    var v = exactVariant() || current;
    var price = q > 1 ? tierPrice(q) : v.price;
    var label = q > 1 ? atc.getAttribute('data-label-multi').replace('[n]', q) : atc.getAttribute('data-label-single');
    atc.textContent = label + ' · ' + money(price);
    syncSticky();
  }
  function syncSticky() { if (stickyBtn) { stickyBtn.textContent = atc.textContent; stickyBtn.disabled = atc.disabled; } }
  tierInputs.forEach(function (r) { r.addEventListener('change', function () { refreshAtc(); showHint(''); }); });

  // ---------- sticky add to cart: shown while the main button is off screen ----------
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var off = !es[0].isIntersecting;
      sticky.classList.toggle('is-on', off);
      if (off) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      document.body.classList.toggle('ef-sticky-on', off);
    }).observe(atc);
    stickyBtn.addEventListener('click', function () {
      var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (sizeOpt && !sel[sizeOpt.position]) {        /* no size yet: take them to the sizes */
        var r = root.querySelector('input[data-ef-opt="' + sizeOpt.position + '"]');
        if (r) r.closest('.ef-group').scrollIntoView({ behavior: smooth, block: 'center' });
        showHint(msg('size', 'pick a size first'), true);
        return;
      }
      atc.click();
      /* a bundle pair still needs a size: the message sits under the main button, so show it */
      if (hint.classList.contains('is-error') && hint.textContent) atc.scrollIntoView({ behavior: smooth, block: 'center' });
    });
  }

  // ---------- size chart: wide charts (more than 5 columns, up to 4 sizes) also get a turned version for phones,
  // sizes across and measurements down, so they fit without sideways scrolling (CSS picks one) ----------
  document.querySelectorAll('dialog.ef-sizes .ef-sizes__scroll table').forEach(function (t) {
    var rows = [].slice.call(t.rows);
    if (!rows.length || rows[0].cells.length <= 5 || rows.length - 1 > 4) return;   /* 5+ sizes: too many columns once turned; CSS compacts it instead */
    var tt = document.createElement('table');
    tt.className = 'ef-sizes__t';
    var head = tt.createTHead().insertRow(), body = tt.createTBody();
    for (var c = 0; c < rows[0].cells.length; c++) {
      var tr = c === 0 ? head : body.insertRow();
      rows.forEach(function (r, i) {
        var cell = document.createElement(c === 0 || i === 0 ? 'th' : 'td');
        cell.scope = c === 0 ? 'col' : 'row';
        cell.innerHTML = r.cells[c] ? r.cells[c].innerHTML : '';
        tr.appendChild(cell);
      });
    }
    t.classList.add('ef-sizes__wide');
    t.parentNode.appendChild(tt);
  });

  // ---------- size chart ----------
  root.querySelectorAll('[data-ef-open]').forEach(function (b) {
    b.addEventListener('click', function () { var d = document.getElementById(b.getAttribute('data-ef-open')); if (d && d.showModal) d.showModal(); });
  });
  document.querySelectorAll('dialog.ef-sizes').forEach(function (d) {
    d.querySelector('[data-ef-close]').addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
  });

  // ---------- add to cart ----------
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (atc.classList.contains('is-busy')) return;
    var v = exactVariant();
    if (!v) { showHint(sizeOpt && !sel[sizeOpt.position] ? msg('size', 'pick a size first') : msg('option', 'pick an option first'), true); return; }
    if (!v.available) { showHint(msg('soldout', 'sold out'), true); return; }
    var q = tierQty();
    var items = [{ id: v.id, quantity: 1 }];
    var names = ['', '', 'pair two', 'pair three'];
    for (var n = 2; n <= q; n++) {
      var st = pairState[q + ':' + n];
      if (!st || !st.size) { showHint(msg('pair', 'pick a size for [label]').replace('[label]', names[n]), true); return; }
      items.push({ id: P.pairs[st.idx].sizes[st.size].id, quantity: 1 });
    }
    var merged = [];
    items.forEach(function (it) { var ex = merged.filter(function (m) { return m.id === it.id; })[0]; if (ex) ex.quantity += 1; else merged.push(it); });

    var drawer = document.querySelector('cart-drawer');
    var body = { items: merged };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
    atc.classList.add('is-busy'); showHint('');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        atc.classList.remove('is-busy');
        if (!res.ok || res.j.status) { showHint(res.j.description || res.j.message || msg('error', 'try again.'), true); return; }
        if (drawer && res.j.sections) {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          if (drawer.setActiveElement) drawer.setActiveElement(atc);
          drawer.renderContents(res.j);
        } else {
          location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { atc.classList.remove('is-busy'); showHint(msg('error', 'try again.'), true); });
  });

  // ---------- boot ----------
  if (colorOpt) { var s0 = slideFor(sel[colorOpt.position]); if (s0 > 0) go(s0, false); }
  refreshVariant();
  window.addEventListener('pageshow', function (e) { if (e.persisted) atc.classList.remove('is-busy'); });
})();
